module.exports = __webpack_public_path__ + "static/media/07.d577f608.png";